<script>
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  components: {
    CommonTableComponent
  },
  mixins: [pagination, tableSearch],
  props: ['dataSearch','isEdit'],
  data() {
    return {
      user_selected: '',
      busyGetData: false,
      data: [],
      visible: false,
      departmentOptions: [],
      filters: {
        department_id: "",
        column: "",
        dir: "ASC",
      }
    };
  },
  created() {
    this.getOptionsDepartment();
  },
  methods: {
    async getOptionsDepartment() {
      const response = await this.$http.get(apiEndpoints.department_list_options, {
        ...this.filters,
      });
      const { status, data } = response;
      if (status) {
        this.departmentOptions = data.result;
      }
    },
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.popup_search_users_by_department, {
        ...this.filters,
      });
      const { status, data } = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.data = this.$_.isEmpty(result) ? [] : result;
      }
      this.user_selected = this.dataSearch.user_name;
    },
    updateValue: function(value) {
      this.$emit('dataSelected', value)
      this.closeModal();
    },
    closeModal() {
      this.$bvModal.hide("modal-select-data-worker");
    },
    performDebounceSearch () {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    updateUrlFilters () {
      this.getData()
    },
  },
  watch: {
    "filters.department_id": {
      handler() {
        this.performDebounceSearch();
      }
    }
  },
  computed: {
    headers() {
      return [
        {
            text: '部門',
            value: 'department_id',
            sortable: true
        },
        {
            text: '作業者',
            value: 'user_name',
            sortable: true
        }
      ];
    },
    inputSearch: {
      get() {
        return this.dataSearch.user_name;
      },
      set(newValue) {
        this.$emit('dataSelected', newValue)
      }
    },
  }
};
</script>
<template>
  <div class="d-flex gap-2">
    <label class="col-form-label text-nowrap me-2" style="margin-right: 52px !important;" for="nameStaff">作業者</label>
    <input
      type="text"
      class="form-control"
      v-model="inputSearch"
      width="100%"
    />
    <b-button
      v-b-modal.modal-select-data-worker
      variant="outline-info"
    ><i class="bx bx-file-find"></i></b-button>
    <!-- modal area -->
    <b-modal
      size="lg"
      title="社員一覧"
      id="modal-select-data-worker"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
    <b-overlay
      :show="busyGetData"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block w-100"
    >
      <b-row class="text-center">
        <div class="custom-select gap-2 col-8">
            <label class="lbl-custom" for="department"
                >部門</label
            >
            <b-form-select
                id="department"
                :options="[{id: '', name: '全て'}, ...departmentOptions]"
                v-model="filters.department_id"
                value-field="id"
                text-field="name"
                class="form-select custom-select"
            ></b-form-select>
            </div>
      </b-row>
      <b-row class="mt-2">
        <CommonTableComponent :height-class="`table-wrapper-500`">
          <thead class="table-light">
            <tr>
              <th
                v-for="(item, index) in headers"
                :key="index"
                :class="getHeaderClass(item)"
              >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
                <span v-else>
                  {{ item.text }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in data"
              :key="index"
              class="cursor-pointer"
              @click="updateValue(item.user_name)"
            >
              <td>
                {{ item.department_name }}
              </td>
              <td>
                {{ item.user_name }}
              </td>
            </tr>
            <tr v-if="!data.length && !busyGetData">
              <td :colspan="headers.length + 1" class="text-center">
                データなし。
              </td>
            </tr>
          </tbody>
        </CommonTableComponent>
      </b-row>
    </b-overlay>
    </b-modal>
  </div>
</template>
